export default {
    sections: ['details'],
    groups: {
        contact_details: {
            component: {
                template: `<div class="form-row">
                    <div class="col-sm-6">
                        <slot name="firstname" />
                        <slot name="lastname" />
                        <slot name="email" />
                        <slot name="import_id" />
                    </div>
                </div>`
            }
        }
    },
    toolbar: [],
    fields: {
        firstname: {
            section: 'details',
            group: 'contact_details',
            position: 0,
        },
        lastname: {
            section: 'details',
            group: 'contact_details',
            position: 1,
        },
        email: {
            section: 'details',
            group: 'contact_details',
            position: 2,
        },
        import_id: {
            label: 'SendGrid ID',
            group: 'contact_details',
            section: 'details',
            position: 3,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.contact.js